import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'
import ResetPassword from '../views/resetPassword/index.vue'
import FaceList from '../views/face-list/index'
import ClassDetail from '../views/class-detail/index'
import TrainDetail from '../views/train-detail/index'
import PublicInformationDetail from '../views/publicInformationDetail/index.vue'
import PublicInformationDetailMobile from '../views/publicInformationDetail/indexmobile.vue'
import PublicInformationList from '../views/publicInformationList/index.vue'
import CooperationApply from '../views/cooperationApply/index.vue'
import PublicTemp from '../views/tempPage/index.vue'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originPush = VueRouter.prototype.push

VueRouter.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(this, location, resolve, reject)
  } else {
    originPush.call(this, location, () => {}, () => {})
  }
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/faceList',
    name: 'FaceList',
    component: FaceList
  },
  {
    path: '/classDetail',
    name: 'ClassDetail',
    component: ClassDetail
  },
  {
    path: '/trainDetail',
    name: 'TrainDetail',
    component: TrainDetail
  },
  {
    path: '/teacherList',
    name: 'TeacherList',
    component: () => import('@/views/teacherList/index.vue')
  },
  {
    path: '/teacherIntroduce',
    name: 'TeacherIntroduce',
    component: () => import('@/views/teacherIntroduce/index.vue')
  },
  {
    path: '/talentService',
    name: 'TalentService',
    component: () => import('@/views/talentService/index.vue')
  },
  {
    path: '/talentServiceDetail',
    name: 'TalentServiceDetail',
    component: () => import('@/views/talentService/talentServiceDetail/index.vue')
  },
  {
    path: '/talentServiceDetailMobile',
    name: 'TalentServiceDetailMobile',
    component: () => import('@/views/talentService/talentServiceDetail/indexmobile.vue')
  },
  {
    path: '/publicInformationList',
    name: 'PublicInformationList',
    component: PublicInformationList
  },
  {
    path: '/publicInformationDetail',
    name: 'PublicInformationDetail',
    component: PublicInformationDetail
  },
  {
    path: '/publicInformationDetailMobile',
    name: 'PublicInformationDetailMobile',
    component: PublicInformationDetailMobile
  },
  {
    path: '/testPlan',
    name: 'TestPlan',
    component: () => import('@/views/testPlan/index.vue')
  },
  {
    path: '/careerMatrix/:type',
    name: 'CareerMatrix',
    component: () => import('@/views/careerMatrix/index.vue')
  },
  {
    path: '/aboutUs',
    name: 'AboutUs',
    component: () => import('@/views/aboutUs/index.vue')
  },
  {
    path: '/institutions',
    name: 'Institutions',
    component: () => import('@/views/institutions/index.vue')
  },
  {
    path: '/cooperationApply',
    name: 'CooperationApply',
    component: CooperationApply
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/search/index.vue')
  },
  {
    path: '/search/detail',
    name: 'SearchDetail',
    component: () => import('@/views/search/detail.vue')
  },
  {
    path: '/certificate',
    name: 'Certificate',
    component: () => import('@/views/certificate/index.vue')
  },
  {
    path: '/certificateDetail',
    name: 'CertificateDetail',
    component: () => import('@/views/certificate/detail.vue')
  },
  {
    path: '/veteran',
    name: 'Veteran',
    component: () => import('@/views/veteran/index.vue')
  },
  {
    path: '/veteranList',
    name: 'VeteranList',
    component: () => import('@/views/veteranList/index.vue')
  },
  {
    path: '/veteranDetail',
    name: 'VeteranDetail',
    component: () => import('@/views/veteranDetail/index.vue')
  },
  {
    path: '/veteranDetailMobile',
    name: 'VeteranDetailMobile',
    component: () => import('@/views/veteranDetail/indexmobile.vue')
  },
  {
    path: '/authorityList',
    name: 'AuthorityList',
    component: () => import('@/views/authorityList/index.vue')
  },
  {
    path: '/authorityDetail',
    name: 'VeteranDetail',
    component: () => import('@/views/authorityDetail/index.vue')
  },
  {
    path: '/authorityDetailMobile',
    name: 'AuthorityDetailMobile',
    component: () => import('@/views/authorityDetail/indexmobile.vue')
  },
  {
    path: '/publicTemp',
    name: 'PublicTemp',
    component: PublicTemp
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

let isMobile = false
detectDeviceType()

function detectDeviceType () {
  const machineType = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop'
  if (machineType === 'Mobile') {
    isMobile = true
  }
}

router.beforeEach((to, from, next) => {
  // 统一处理特殊功能
  if (Vue.prototype._isMobile) {
    const mobilePath = ['Certificate']
    const bodyStyle = document.body.style
    if (mobilePath.includes(to.name)) {
      bodyStyle.minWidth = 'unset'
    } else {
      bodyStyle.minWidth = '1300px'
    }
  }
  if (to.name === from.name && (['AboutUs', 'TalentService', 'CareerMatrix', 'AuthorityList'].includes(to.name))) {
    next()
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
  } else if (from.name) {
    if (isMobile) {
      // chrome
      document.body.scrollTop = 0
      // firefox
      document.documentElement.scrollTop = 0
      // safari
      window.pageYOffset = 0
      next()
    } else {
      window.open(window.location.origin + to.fullPath)
    }
  } else {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
  }
})

export default router
